import axios from "axios";
import React, { useEffect, useState } from "react";
import { Autoplay, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";

const TeachersMessage = () => {
  const [teachersMessages, setTeachersMessages] = useState([]);
  useEffect(() => {
    axios.get("JSON/teachersMessages.json").then((response) => {
      setTeachersMessages(response.data[0]);
    });
  }, []);

  return (
    <>
      <section className="eschool-teachers-message">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="section-head">
                <h3 className="section-head-title">
                  {teachersMessages?.header_title}
                </h3>
                <p className="section-head-text">
                  {teachersMessages?.sort_detail}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="teachers-message-inner">
                <Swiper
                  modules={[Navigation, Autoplay]}
                  spaceBetween={30}
                  slidesPerView={2}
                  //   onSlideChange={() => console.log("slide change")}
                  //   onSwiper={(swiper) => console.log(swiper)}
                  navigation
                  loop={true}
                  autoplay={false}
                  breakpoints={{
                    // when window width is >= 320px
                    320: {
                      width: 320,
                      slidesPerView: 1,
                    },
                    // when window width is >= 768px
                    768: {
                      width: 768,
                      slidesPerView: 1,
                    },
                    // when window width is >= 1440px
                    1440: {
                      width: 1440,
                      slidesPerView: 2,
                    },
                  }}
                >
                  {teachersMessages?.comments?.map((singleComment) => (
                    <SwiperSlide key={singleComment.id}>
                      <div className="teachers-message-single">
                        <div className="teachers-message-left">
                          <div className="teachers-msg-left-content">
                            <h4 className="teachers-msg-left-title">
                              {singleComment.name}
                            </h4>
                            <h6 className="teachers-msg-left-tag">
                              {singleComment.title}
                            </h6>
                            <p className="teachers-msg-left-experience">
                              School experience:
                              <span className="teachers-msg-left-experience-year">
                                <i className="fi-rs-badge"></i>
                                {singleComment.experience}
                              </span>
                            </p>
                          </div>
                          <div className="teachers-message-img">
                            <img src={singleComment.img} alt="#" />
                          </div>
                        </div>
                        <div className="teachers-message-right">
                          <p className="teachers-message-right-text">
                            {singleComment.message}
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TeachersMessage;
